import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { compose } from '../../../../../../../src/web/utils/react';
import mixpanel from '../../../../../../../src/web/utils/mixpanel';
import { TRACK_CLICK_RESERVE, trackDataLayerEvent } from '../../../../../../../src/web/utils/dataLayer';
import {
  showModal as showReservationModal,
  hideModal as hideReservationModal,
  submit,
} from '../../../../../../../src/web/store/modules/reservations';
import {
  submit as submitEvents,
} from '../../../../../../../src/web/store/modules/websiteEvents';
import CurrentPageContext from '../../../../../../contexts/CurrentPageContext';
import ReservationModal from './ReservationModal';

class Reservation extends React.Component {
  static propTypes = {
    closeSelectedUnitModal: PropTypes.func,
    facility: PropTypes.shape({
      id: PropTypes.string.isRequired,
      hasRentalCenter: PropTypes.bool,
      reservationFeeRequired: PropTypes.bool,
    }).isRequired,
    site: PropTypes.shape({
      companyId: PropTypes.string.isRequired,
      identifier: PropTypes.string.isRequired,
    }).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    inModalContext: PropTypes.bool,
    reservationUrl: PropTypes.string,
    shouldShowModal: PropTypes.bool.isRequired,
    showModal: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    enableTieredPricing: PropTypes.bool,
    setTrackAction: PropTypes.func,
    toggleTiers: PropTypes.func,
  };

  static defaultProps = {
    closeSelectedUnitModal: undefined,
    inModalContext: false,
    reservationUrl: undefined,
    enableTieredPricing: false,
    setTrackAction: undefined,
    toggleTiers: () => { },
  };

  static contextType = CurrentPageContext;

  handleClick = () => {
    const {
      closeSelectedUnitModal,
      facility: { reservationFeeRequired },
      id,
      inModalContext,
      showModal,
      toggleTiers,
      enableTieredPricing,
      setTrackAction,
    } = this.props;
    if (setTrackAction) {
      setTrackAction('reservation');
    }
    trackDataLayerEvent(TRACK_CLICK_RESERVE);

    if (inModalContext) {
      closeSelectedUnitModal?.();
    }

    if (!reservationFeeRequired) {
      if (enableTieredPricing && inModalContext) {
        toggleTiers('reserve');
      }
      return showModal(id);
    }
    return null;
  };

  handleSubmitSuccess = (response) => {
    const {
      site: { companyId, identifier },
    } = this.props;


    mixpanel.trackReservation(
      { companyId, companyIdentifier: identifier },
      get(response, 'data.receipt.tenant'),
    );
  };

  renderModal() {
    const { handleSubmit, hideModal, sendEvents, ...props } = this.props;
    return (
      <ReservationModal
        {...props}
        onSubmit={handleSubmit}
        onSubmitSuccess={this.handleSubmitSuccess}
        onClose={hideModal}
      />
    );
  }

  getClassNames() {
    const { secondaryColorBackgroundClass, primaryColorBackgroundHoverClass,
      buttonStyleClass } = this.context;
    const { isUnitGroupExpanded, styleReservationUG } = this.props;

    return cx(
      'w-100',
      secondaryColorBackgroundClass,
      primaryColorBackgroundHoverClass,
      buttonStyleClass,
      !isUnitGroupExpanded && 'action-reservation',
      isUnitGroupExpanded && styleReservationUG,
    );
  }

  render() {
    const {
      facility: { reservationFeeRequired },
      reservationUrl,
      shouldShowModal,
      text,
      id,
    } = this.props;

    if (reservationFeeRequired) {
      return (
        <Button
          block
          className={this.getClassNames()}
          href={reservationUrl}
          onClick={this.handleClick}
          rel="noopener noreferrer"
          target="_blank"
          data-event={'reserve'}
          data-button-text={text}
          data-reservationUrl={reservationUrl}
          data-id={id}
          {...TRACK_CLICK_RESERVE}
        >
          {text}
        </Button>
      );
    }

    return (
      <>
        {shouldShowModal && this.renderModal()}
        <Button
          className={this.getClassNames()}
          block
          onClick={this.handleClick}
          data-event={'reserve'}
          data-reservationUrl={reservationUrl}
          data-button-text={text}
          data-reservationId={id}
          {...TRACK_CLICK_RESERVE}
        >
          {text}
        </Button>
      </>
    );
  }
}

export default compose(
  connect(
    ({ reservations, site, page, user }, { id }) => ({
      shouldShowModal: reservations.activeGroup === id,
      isSubmitting: reservations.submitting,
      error: reservations.error,
      receipt: reservations.receipt,
      pageId: page?.id,
      facilityId: page?.facilityId,
      pageVersion: page?.publishedVersion?.id,
      userLat: user?.userLocation?.latitude,
      userLong: user?.userLocation?.longitude,
      site,
    }),
    {
      showModal: showReservationModal,
      hideModal: hideReservationModal,
      handleSubmit: submit,
      sendEvents: submitEvents,
    },
  ),
)(Reservation);
